import React from 'react'
import Slider from 'react-slick';
import { ServicesSkeleton } from "./SkeletonLoader";

const Services = ({services, selectedService, setSelectedService, loading = false}) => {
    const rawServiceItems = Array.isArray(services?.cell_contents) ? services.cell_contents : [];
    const serviceItems = rawServiceItems.filter((item) => {
        const serviceName = String(item?.name || item?.title || item?.service_name || "").trim().toLowerCase();
        return serviceName !== "offer" && serviceName !== "offers";
    });

    if (loading) {
        return <ServicesSkeleton />;
    }

    if (!serviceItems.length) {
        return null;
    }

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: serviceItems.length > 10,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: false,   // ensure ye false ho
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1699,
                settings: {
                    slidesToShow: 9,
                },
            },
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 8,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 359,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };
    return (
        <div className="feature orders-services-section py-24" id="featureSection">
            <div className="container container-lg">
                <h5 className="mb-10 gap-8">{services?.cell_title_text}</h5>
                <div className="position-relative arrow-center">
                    <div className="flex-align">
                        <button
                            type="button"
                            id="feature-item-wrapper-prev"
                            className="slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                        >
                            <i className="ph ph-caret-left" />
                        </button>
                        <button
                            type="button"
                            id="feature-item-wrapper-next"
                            className="slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                        >
                            <i className="ph ph-caret-right" />
                        </button>
                    </div>
                    <div className="feature-item-wrapper">
                        <Slider {...settings}>
                        {serviceItems.map((item, index) => {
                            const isActive = item.segment_id === selectedService?.segment_id;

                            return (
                              <div className="feature-item text-center" key={item?.segment_id || item?.id || index} onClick={() => setSelectedService(item)}>

                                <div className="feature-item__thumb rounded-circle">
                                  <div className="w-100 h-100 flex-center">
                                    <img src={item.image} alt={item.name} className="feature-item__image orders-service-image"/>
                                  </div>
                                </div>

                                <div className={`feature-item__content mt-16 ${isActive ? "orders-service-active" : ""}`}>
                                  <h6 className="text-lg mb-8">
                                    <div className="text-inherit orders-service-name">
                                      {isActive && (
                                        <span className="orders-service-active-icon" aria-hidden="true">
                                          <i className="ph ph-check" />
                                        </span>
                                      )}
                                      <span>{item.name}</span>
                                    </div>
                                  </h6>

                                  {/* Optional */}
                                  {/* <span className="text-sm text-gray-400">{item.product_count} Products</span> */}

                                </div>

                              </div>

                            );
                        })}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Services
